import queryString from 'query-string';
import { apiFetch } from './utils/api';

// eslint-disable-next-line no-unused-vars
const mockedPortfolioIndex = require('./mocks/v3/portfolio-index.json');

export const portfolioIndices = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `v3/portfolio/portfolio-index?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
